import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["green-button-container", ({ active: $setup.props.active }, { 'un-active': !$setup.props.active })]),
    tabindex: "0"
  }, _toDisplayString($props.title), 3))
}